'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? '#000' : _ref$fill,
      className = _ref.className,
      path = _ref.path;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24',
      className: className
    },
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { fill: fill, d: path })
  );
};

Icon.propTypes = {
  size: _propTypes2.default.number,
  fill: _propTypes2.default.string,
  className: _propTypes2.default.string,
  path: _propTypes2.default.string.isRequired
};

exports.default = Icon;


// WEBPACK FOOTER //
// ./node_modules/react-ideal-image/dist/components/Icon/index.js